import { render, staticRenderFns } from "./Descarga.vue?vue&type=template&id=662b773d"
import script from "./Descarga.vue?vue&type=script&lang=js"
export * from "./Descarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports